import Konva from "konva/cmj/index";
import * as ts from "../common/Translator";


export class NamaKonvaCanvas {
    constructor({
                    containerId,
                    width,
                    height,
                    shouldAddSelector,
                    backgroundGridCellWidth,
                    backgroundGridCellHeight,
                    backgroundGridColumnCount,
                    backgroundGridRowsCount,
                    ignoreXPixelsInBackground,
                    ignoreYPixelsInBackground
                }) {
        this.ignoreXPixelsInBackground = ignoreXPixelsInBackground || 0;
        this.ignoreYPixelsInBackground = ignoreYPixelsInBackground || 0;
        this.containerId = containerId;
        this.width = width;
        this.height = height;
        this.selectableShapes = [];
        this.backgroundGridCellWidth = backgroundGridCellWidth;
        this.backgroundGridCellHeight = backgroundGridCellHeight;
        this.shouldAddSelector = shouldAddSelector;
        this.transformers = [];
        if (backgroundGridColumnCount && width)
            this.backgroundGridCellWidth = Math.round(width / backgroundGridColumnCount);
        if (backgroundGridRowsCount && height)
            this.backgroundGridCellHeight = Math.round(height / backgroundGridRowsCount);
    }

    addField(entityType, fieldId) {
        this.addShapes(this.createField(entityType, fieldId));
    }

    createField(entityType, fieldId) {
        let width = this.backgroundGridCellWidth;
        let yPadding = 5, fieldHeight = this.backgroundGridCellHeight - 10;
        let fieldWidth = width - 5;
        const group = new Konva.Group({
            width: fieldWidth,
            height: fieldHeight,
            draggable: true,
            x: this.selectableShapes.length % 2 == 1 ? 0 : width,
            y: Math.floor(this.selectableShapes.length / 2) * this.backgroundGridCellHeight + 5,
        });
        group.add(
            new Konva.Rect({
                width: fieldWidth * 3 / 4,
                x: 100,
                height: fieldHeight,
                fill: "white",
                stroke: "black",
                strokeWidth: 1
            }),
            new Konva.Text({text: ts.translateIdInEnglish(fieldId, entityType), padding: 5, width: fieldWidth / 4})
        );
        return group;
    }

    draw() {
        let that = this;
        let stage = that.stage = new Konva.Stage({
            container: that.containerId,
            width: that.width,
            height: that.height,
        });
        let layer = that.layer = new Konva.Layer();
        let tooltip = that.tooltip = new Konva.Group({
            visible: false
        });
        tooltip.add(new Konva.Rect({
            fill: "#FFF6BF",
            stroke: "black",
            strokeWidth: 1
        }), new Konva.Text({
            text: '',
            fontFamily: 'Calibri',
            fontSize: 14,
            padding: 2,
            fill: 'black',
            alpha: 0.75,
        }))
        layer.add(tooltip)
        if (that.shouldAddSelector)
            that.addSelector();
        if (that.backgroundGridCellHeight || that.backgroundGridCellWidth)
            that.drawBackgroundGrid();
        stage.add(layer);
    }

    getTooltipText() {
        return this.fetchFirstChildWithClassName(this.tooltip, 'Text');
    }

    getTooltipRect() {
        return this.fetchFirstChildWithClassName(this.tooltip, 'Rect');
    }

    fetchFirstChildWithClassName(group, className) {
        return group.getChildren().filter(l => l.getClassName() === className)[0];
    }

    addShapes(...shapes) {
        this.addShapesToSelectableList(...shapes);
        this.addShapesToLayer(...shapes);
    }

    addShapesToSelectableList(...shapes) {
        let that = this;
        that.selectableShapes.push(...shapes);
    }

    addShapesToLayer(...shapes) {
        this.layer.add(...shapes);
    }

    addSelector() {
        let that = this;
        let tr = that.transformer = new Konva.Transformer({
            rotateEnabled: false,
            draggable: true,
            shouldOverdrawWholeArea: true,
        }), layer = that.layer, stage = that.stage;
        that.transformers.push(tr);
        tr.boundBoxFunc(function (oldBox, newBox) {
            if (newBox.width < 10 || newBox.height < 10) {
                tr.stopTransform();
                return oldBox;
            }
            return newBox;
        });
        that.layer.add(tr);
        let selectionRectangle = this.selectionRectangle = new Konva.Rect({
            fill: 'rgba(0,0,255,0.5)',
            visible: false,
        });
        layer.add(selectionRectangle);
        let x1, y1, x2, y2;
        stage.on('mousedown touchstart', (e) => {
            // do nothing if we mousedown on any shape
            if (this.findClosestChildShape(e.target)) {
                return;
            }
            if (that.pointerInsideTransformRectangle())
                return;
            x1 = stage.getPointerPosition().x / stage.scaleX();
            y1 = stage.getPointerPosition().y / stage.scaleY();
            x2 = stage.getPointerPosition().x / stage.scaleX();
            y2 = stage.getPointerPosition().y / stage.scaleY();
            e.evt.preventDefault();

            selectionRectangle.visible(true);
            selectionRectangle.moveToTop();
            selectionRectangle.width(0);
            selectionRectangle.height(0);
        });
        stage.on('mousemove touchmove', (e) => {
            // do nothing if we didn't start selection
            if (!selectionRectangle.visible())
                return;
            e.evt.preventDefault();
            x2 = stage.getPointerPosition().x / stage.scaleX();
            y2 = stage.getPointerPosition().y / stage.scaleY();

            selectionRectangle.setAttrs({
                x: Math.min(x1, x2),
                y: Math.min(y1, y2),
                width: Math.abs(x2 - x1),
                height: Math.abs(y2 - y1),
            });
        });
        stage.on('mouseup touchend', (e) => {
            // do nothing if we didn't start selection
            if (!selectionRectangle.visible()) {
                return;
            }
            // update visibility in timeout, so we can check it in click event
            setTimeout(() => {
                selectionRectangle.visible(false);
            });
            if (selectionRectangle.width() === 0)//TODO:: SelectionRectangle
                return;
            e.evt.preventDefault();
            let shapes = that.selectableShapes;
            let box = selectionRectangle.getClientRect();
            let selected = shapes.filter((shape) =>
                Konva.Util.haveIntersection(box, shape.getClientRect())
            );
            that.selectNodes(selected);
        });
        stage.on('click tap', function (e) {
            // if we are selecting with rect, do nothing
            if (selectionRectangle.visible()) {
                return;
            }

            if (that.pointerInsideTransformRectangle())
                return;
            // if click on empty area or non-child shape - remove all selections
            let target = that.findClosestChildShape(e.target);
            if (!target) {
                that.selectNodes([])
                return;
            }

            // did we press shift or ctrl?
            const metaPressed = e.evt.shiftKey || e.evt.ctrlKey || e.evt.metaKey;
            const isSelected = tr.nodes().indexOf(target) >= 0;

            if (!metaPressed && !isSelected) {
                // if no key pressed and the node is not selected
                // select just one
                that.selectNodes([target]);
            } else if (metaPressed && isSelected) {
                // if we pressed keys and node was selected
                // we need to remove it from selection:
                const nodes = tr.nodes().slice(); // use slice to have new copy of array
                // remove node from array
                nodes.splice(nodes.indexOf(target), 1);
                that.selectNodes(nodes);
            } else if (metaPressed && !isSelected) {
                // add the node into selection
                const nodes = tr.nodes().concat([target]);
                that.selectNodes(nodes);
            }
        });
    }

    selectNodes(nodes) {
        for (let node of nodes) {
            node.moveToTop();
        }
        this.transformer.nodes(nodes);
        this.transformer.moveToTop();
        if (nodes && this.selectionCallback)
            this.selectionCallback(nodes);
    }

    drawBackgroundGrid(backgroundGridCellWidth, backgroundGridCellHeight) {
        let that = this;
        backgroundGridCellWidth = backgroundGridCellWidth || that.backgroundGridCellWidth;
        backgroundGridCellHeight = backgroundGridCellHeight || that.backgroundGridCellHeight;
        const xSnaps = backgroundGridCellWidth ? Math.round((that.stage.width() - this.ignoreXPixelsInBackground) / backgroundGridCellWidth) : 0;
        const ySnaps = backgroundGridCellHeight ? Math.round((that.stage.height() - this.ignoreYPixelsInBackground) / backgroundGridCellHeight) : 0;
        const cellWidth = xSnaps ? that.stage.width() / xSnaps : 0;
        const cellHeight = ySnaps ? that.stage.height() / ySnaps : 0;
        for (let i = 0; i < xSnaps + 1; i++) {
            let line = new Konva.Line({
                points: [this.ignoreXPixelsInBackground + i * cellWidth, this.ignoreYPixelsInBackground, this.ignoreXPixelsInBackground + i * cellWidth, that.stage.height()],
                stroke: 'rgba(234, 234, 234, 0.6)',
                strokeWidth: 1,
                name: "bgGridXLine",
            });
            that.layer.add(line);
            line.moveToBottom();
        }

        for (let i = 0; i < ySnaps + 1; i++) {
            let line = new Konva.Line({
                points: [this.ignoreXPixelsInBackground, this.ignoreYPixelsInBackground + i * cellHeight, that.stage.width(), this.ignoreYPixelsInBackground + i * cellHeight],
                stroke: 'rgba(234, 234, 234, 0.6)',
                strokeWidth: 1,
                name: "bgGridYLine",
            });
            that.layer.add(line);
            line.moveToBottom();
        }
    }

    /**
     *
     * @param node {Konva.Node}
     */
    findClosestChildShape(node) {
        if (!node || node instanceof Konva.Layer || node instanceof Konva.Stage)
            return null;
        if (this.selectableShapes.includes(node))
            return node;
        return this.findClosestChildShape(node.parent);
    }

    pointerInsideTransformRectangle() {
        for (let tr of this.transformers) {
            let stage = this.stage;
            let x = stage.getPointerPosition().x;
            let y = stage.getPointerPosition().y;
            let trRect = tr.getClientRect();
            if (x >= trRect.x && x <= trRect.x + trRect.width && y >= trRect.y && y <= trRect.y + trRect.height)
                return true;
        }
        return false;
    }
}